// ═══════════════════════════════════════════════════
// PROTECONS SOLUTIONS — Application Constants
// ═══════════════════════════════════════════════════

export const COMPANY = {
  name: "Protecons Solutions Private Limited",
  shortName: "Protecons",
  tagline: "Niche in the Niche — Guidewire Excellence",
  founded: 2018,
  cin: "U74999UP2018PTC110655",
  website: "https://proteconsol.com",
  email: "contact@proteconsol.com",
  address: {
    line1: "Swastik Towers, CP-17/18, Mahanagar",
    line2: "Pilibhit Bypass Road",
    state: "Bareilly, Uttar Pradesh – 243005",
    country: "India",
  },
  hours: "Mon–Fri: 9:00 AM – 6:00 PM IST",
};

export const SOCIAL_LINKS = [
  {
    platform: "LinkedIn",
    url: "https://www.linkedin.com/company/protecons/",
    icon: "linkedin",
  },
  /*  {
    platform: "Instagram",
    url: "https://www.instagram.com/protecons_solutions/",
    icon: "instagram",
  },
  { platform: "Twitter", url: "https://x.com/protecons", icon: "twitter" }, */
];

export const NAV_LINKS = [
  { label: "Home", path: "/", id: "hero" },
  { label: "About", path: "/about", id: "about" },
  { label: "Services", path: "/services", id: "services" },
  { label: "Capabilities", path: "/non-guidewire", id: "capabilities" },
  { label: "Architecture", path: "/architecture", id: "architecture" },
  { label: "Global Reach", path: "/global-reach", id: "global" },
  { label: "Products", path: "/products", id: "products" },
  { label: "Our Team", path: "/team", id: "team" },
  { label: "Events", path: "/events", id: "events" },
  { label: "Publications", path: "/publications", id: "publications" },
  { label: "Careers", path: "/careers", id: "careers" },
  { label: "Contact", path: "/contact", id: "contact" },
];

export const STATS = [
  { value: 50, suffix: "+", label: "Guidewire Experts", icon: "👥" },
  { value: 100, suffix: "+", label: "Projects Delivered", icon: "📦" },
  { value: 100, suffix: "%", label: "Certified Workforce", icon: "🏅" },
  { value: 8, suffix: "+", label: "Years in Guidewire", icon: "📅" },
  { value: 5, suffix: "", label: "Continents Served", icon: "🌍" },
];

export const SERVICES = [
  {
    id: "policycenter",
    title: "PolicyCenter",
    description:
      "Full lifecycle PolicyCenter implementation — underwriting workflows, product model configuration, rating engine setup, policy issuance, endorsements, cancellations, audits, and regulatory compliance. Tailored solutions that optimize policy operations end-to-end.",
    features: [
      "Product Model Development",
      "Underwriting Workflows",
      "Rating Engine Configuration",
      "Regulatory Compliance",
      "Reinsurance Integration",
      "Renewal Processing",
    ],
    color: "#00c2ff",
    icon: "📋",
  },
  {
    id: "billingcenter",
    title: "BillingCenter",
    description:
      "Comprehensive billing services including plan configuration, payment gateway integration, commission management, delinquency workflows, disbursement processing, account reconciliation, and financial reporting integration.",
    features: [
      "Billing Plan Setup",
      "Payment Processing",
      "Commission Workflows",
      "Delinquency Management",
      "Account Reconciliation",
      "Financial Integrations",
    ],
    color: "#00e676",
    icon: "💳",
  },
  {
    id: "claimcenter",
    title: "ClaimCenter",
    description:
      "Expert consulting covering FNOL configuration, claims adjudication workflows, reserve management, litigation tracking, subrogation, SIU/fraud detection, ISO/NICB integration, and vendor management for faster claims resolution.",
    features: [
      "FNOL Configuration",
      "Claims Workflows",
      "Reserve Management",
      "ISO/NICB Integration",
      "Subrogation Engine",
      "SIU & Fraud Detection",
    ],
    color: "#ffd600",
    icon: "🛡️",
  },
  {
    id: "integration",
    title: "Integration Services",
    description:
      "Robust integration solutions connecting Guidewire with external systems via REST APIs, SOAP services, messaging queues, ETL pipelines, CRM systems, payment gateways, document management, and legacy mainframes.",
    features: [
      "REST & SOAP APIs",
      "Message Queues",
      "ETL & Batch Processing",
      "CRM Connectivity",
      "Payment Gateways",
      "Legacy System Bridge",
    ],
    color: "#ff6b35",
    icon: "🔗",
  },
  {
    id: "cloud",
    title: "Cloud Migration",
    description:
      "Seamless on-premise to Guidewire Cloud migration — assessment, cloud readiness evaluation, architecture redesign, data migration, CI/CD pipeline setup, environment configuration, and zero-downtime go-live support.",
    features: [
      "Cloud Readiness Assessment",
      "Architecture Redesign",
      "Data Migration Strategy",
      "CI/CD Pipeline Setup",
      "Performance Optimization",
      "Go-Live Support",
    ],
    color: "#a78bfa",
    icon: "☁️",
  },
  {
    id: "jutro",
    title: "Guidewire Digital Portal",
    description:
      "Enterprise-scale Guidewire Digital Portal solutions leveraging EnterpriseEngage and Jutro Digital Platform (JDP) to accelerate digital transformation, enhance customer engagement, and modernize insurance distribution channels.",
    features: [
      "Full Lifecycle Portal Development, Enhancement & Support",
      "Guidewire Digital Portal Development with Jutro Digital Platform (JDP)",
      "EnterpriseEngage Customization & Implementations",
      "Multi-LOB Digital Solutions for Personal & Commercial Insurance",
      "Secure Authentication, Authorization & Identity Integrations",
      "Enterprise UI Component Frameworks & Reusable Design Systems",
      "Automated Testing Strategy with Jest & React Testing Library",
      "Cloud-Ready Portal Modernization & Performance Optimization",
      "Scalable React, JavaScript & TypeScript Frontend Engineering",
      "Seamless Guidewire InsuranceSuite API & Integration Services",
      "Accessibility, Responsive Design & Enterprise UX Standards",
    ],
    color: "#06b6d4",
    icon: "🎨",
  },
  {
    id: "digital",
    title: "Digital Products",
    description:
      "Modern customer, agent, and vendor portals using Guidewire Digital products — self-service capabilities, real-time policy views, claims tracking, document management, and mobile-responsive design.",
    features: [
      "Customer Self-Service",
      "Agent Desktop Portal",
      "Vendor Management",
      "Document Upload/View",
      "Real-Time Tracking",
      "Mobile Responsive",
    ],
    color: "#f472b6",
    icon: "💻",
  },
  {
    id: "upgrades",
    title: "Upgrades & IGApps",
    description:
      "Smooth Guidewire version upgrades and IGApps implementation with proven methodologies — automated merge analysis, regression testing, phased rollout strategies, and post-upgrade stabilization support.",
    features: [
      "Version Upgrade Planning",
      "Merge & Conflict Resolution",
      "IGApps Implementation",
      "Automated Regression",
      "Phased Rollout",
      "Post-Upgrade Support",
    ],
    color: "#34d399",
    icon: "⬆️",
  },
];

export const PRODUCTS = [
  {
    name: "Pro(T) Conversion",
    description:
      "Automated data conversion accelerator reducing migration effort by up to 60%. Complex legacy-to-Guidewire data transformation with built-in validation and rollback.",
    tag: "Data Migration",
  },
  {
    name: "Pro(T) Automaton",
    description:
      "Intelligent test automation framework purpose-built for Guidewire. 10x faster regression cycles with comprehensive functional, integration, and E2E coverage.",
    tag: "Test Automation",
  },
  {
    name: "Pro(T) GoEstimate",
    description:
      "AI-powered estimation tool for accurate project scoping, effort estimation, and resource planning. Leverages historical data from 100+ projects.",
    tag: "Estimation",
  },
  {
    name: "Pro(T) SprintForge",
    description:
      "Agile delivery accelerator with pre-built sprint templates, automated ceremonies, real-time velocity tracking, and burndown analytics.",
    tag: "Agile Delivery",
  },
  {
    name: "Pro(T) BusinessTribe",
    description:
      "Collaborative platform for BAs, devs, QAs, and stakeholders. Seamless requirements management, traceability, and sign-off workflows.",
    tag: "Collaboration",
  },
];

export const GLOBAL_OFFICES = [
  {
    lon: 77.6,
    lat: 12.97,
    label: "India (HQ)",
    sub: "Bareilly · Noida · Bangalore",
    primary: true,
  },
  { lon: -98, lat: 40, label: "North America", sub: "USA & Canada" },
  { lon: 8, lat: 51, label: "Europe", sub: "UK & EU" },
  {
    lon: 103.8,
    lat: 1.3,
    label: "Southeast Asia",
    sub: "Singapore & Malaysia",
  },
  { lon: 133, lat: -26, label: "Australia", sub: "Sydney & Melbourne" },
];

export const CLIENT_SEGMENTS = [
  { name: "P&C Insurance Carriers", region: "North America", icon: "🏢" },
  { name: "Multi-line Insurers", region: "Europe", icon: "🌐" },
  { name: "Regional Carriers", region: "APAC", icon: "📍" },
  { name: "InsurTech Startups", region: "Global", icon: "🚀" },
  { name: "Reinsurance Firms", region: "Global", icon: "🔄" },
  { name: "Workers' Comp Specialists", region: "North America", icon: "⚕️" },
];

export const INDUSTRIES = [
  "P&C Insurance",
  "Healthcare",
  "Banking & Finance",
  "Workers' Compensation",
  "Commercial Lines",
  "Personal Lines",
  "Specialty Insurance",
  "Reinsurance",
];

export const TECH_STACK = [
  "Gosu",
  "Java",
  "React",
  "TypeScript",
  "Jutro",
  "JDP",
  "REST APIs",
  "GraphQL",
  "AWS",
  "Azure",
  "GCP",
  "Docker",
  "Kubernetes",
  "Jenkins",
  "Git",
  "JIRA",
  "Solr",
  "Elasticsearch",
  "Kafka",
  "RabbitMQ",
];

export const EXPERTISE_COLUMNS = [
  {
    title: "Guidewire Cloud Platform",
    color: "#00c2ff",
    items: [
      "Cloud Console & Management",
      "CI/CD Pipeline Automation",
      "Cloud API Architecture",
      "Environment Configuration",
      "Performance Monitoring",
      "Security & Compliance",
    ],
  },
  {
    title: "Jutro & JDP Framework",
    color: "#a78bfa",
    items: [
      "Jutro Design System",
      "Custom Component Library",
      "JDP App Development",
      "React UI Architecture",
      "Theme & Style Customization",
      "WCAG Accessibility",
    ],
  },
  {
    title: "Integration & DevOps",
    color: "#00e676",
    items: [
      "REST & SOAP API Design",
      "Messaging & Event-Driven",
      "ETL & Batch Processing",
      "Legacy System Migration",
      "Docker & Kubernetes",
      "Jenkins / GitHub Actions",
    ],
  },
];

export const MANAGEMENT_TEAM = [
  {
    id: "ceo",
    name: "Hitesh Kumar",
    title: "Chief Executive Officer",
    sub_title: "(CEO)",
    initials: "HK",
    color: "#00c2ff",
    experience: "20+",
    bio: "With over two decades of industry experience, Hitesh founded Protecons in 2018 with a clear vision. He leveraged his extensive expertise in building Guidewire capability from scratch to establish Protecons as a trusted Guidewire consulting and services partner.",
    linkedin: "https://www.linkedin.com/in/hitesh-kumar-1a739912",
    tags: ["Guidewire", "Founder", "Strategy"],
  },
  {
    id: "coo",
    name: "Anurag Mishra",
    title: "Chief Operating Officer",
    sub_title: "(COO)",
    initials: "AM",
    color: "#ff6b35",
    experience: "32+",
    bio: "With over 32 years of rich professional experience, Anurag joined Protecons as Chief Operating Officer. Known for his strategic acumen and ability to build strong teams, he nurtures future leaders and fosters a culture of collaboration — a people-first approach that aligns seamlessly with the values that define Protecons.",
    linkedin: "https://www.linkedin.com/in/anumishra/",
    email: "anurag.m@proteconsol.com",
    tags: ["Leadership", "Strategy", "Operations"],
  },
  {
    id: "dir-digital",
    name: "Mahendra Pal Singh",
    title: "Senior Director",
    sub_title: "(Guidewire Digital Capability Lead)",
    initials: "MS",
    color: "#a78bfa",
    experience: "19+",
    bio: "With over 19 years of industry experience, Mahendra leads Protecons' Guidewire Digital and Product Engineering Services. As the Director and Guidewire Digital Capability Lead, he drives innovative solutions and spearheads digital transformation initiatives.",
    linkedin: "https://www.linkedin.com/in/mahendra-singh-84793b228",
    tags: ["GW Digital", "Product Eng", "Digital Lead"],
  },
  {
    id: "dir-core",
    name: "Varun Manjappa",
    title: "Senior Director",
    sub_title: "(Guidewire Core Capability Lead)",
    initials: "VM",
    color: "#00e676",
    experience: "19+",
    bio: "With over 19 years of experience in Guidewire core, Varun leads Protecons' Guidewire Core Capability with exceptional expertise and strategic vision. His extensive background has been pivotal in establishing and scaling Protecons' core Guidewire services.",
    linkedin: "https://www.linkedin.com/in/varun-manjappa-b2bb1a86",
    tags: ["GW Core", "Core Lead", "Insurance Tech"],
  },
  {
    id: "sr-dir-hr",
    name: "Tanu Mishra",
    title: "Senior Director",
    sub_title: "(Talent Acquisition)",
    initials: "TM",
    color: "#f472b6",
    experience: "11+",
    bio: "With over 11 years of industry experience, Tanu leads Human Resources and Operations at Protecons. Her strategic approach to people and culture has been vital in building Protecons' strong team and fostering a workplace where talent thrives.",
    linkedin: "https://www.linkedin.com/in/tanu-mishra-b79aa2209",
    tags: ["Talent Mgmt", "Recruitment"],
    imageStyle: { objectPosition: "center top" },
  },
  {
    id: "sr-dir-ld",
    name: "Atul Kumar Singh",
    title: "Senior Director HR",
    sub_title: "(Operations & L&D)",
    initials: "AKS",
    color: "#ffd600",
    experience: "15+",
    bio: "With over 15 years of industry experience, Atul serves as Senior Director overseeing both HR Operations and Learning & Development. His dual focus on operational excellence and people development ensures Protecons builds a high-performing, future-ready workforce.",
    linkedin: "https://www.linkedin.com/in/atul-kumar-singh-aa767520",
    tags: ["HR Ops", "L&D", "Capability"],
  },
  {
    id: "pa-strategy",
    name: "Puneet Kumar Gupta",
    title: "Director of Engineering",
    initials: "PKG",
    color: "#00c2ff",
    experience: "21",
    bio: "With 21 years of industry experience, Puneet serves as Director of Engineering at Protecons. He brings a sharp focus on recommending strategic changes and crafting roadmaps that unlock potential and fuel sustainability growth, helping Protecons refine its focus as the company scales",
    linkedin: "https://www.linkedin.com/in/puneetkrgupta",
    tags: ["Principal Arch", "Strategy", "Change Mgmt"],
  },
];

export const ARCHITECTS_TEAM = [
  {
    id: "pa-integration",
    name: "Sripadaraja Purushothama",
    title: "Principal Architect",
    sub_title: "(Guidewire Integration)",
    initials: "SP",
    color: "#ff6b35",
    experience: "17+",
    bio: "With over 17 years of industry experience, Sripadaraja serves as Principal Architect specializing in Guidewire Integration. His deep expertise in integration architecture has been instrumental in designing robust, scalable integration frameworks for complex insurance systems.",
    linkedin: "https://www.linkedin.com/in/sripadaraja-purushothama-2ab700101",
    tags: ["GW Integration", "Architecture", "Enterprise"],
  },
  {
    id: "pa-core",
    name: "Meenakshi Vadivelu",
    title: "Principal Architect",
    sub_title: "(Guidewire Core)",
    initials: "MV",
    color: "#00e676",
    experience: "19+",
    bio: "With over 19 years of industry experience, Meenakshi brings extensive expertise as Principal Architect specializing in Guidewire Core. Her deep knowledge of core platform architecture has been critical in designing and delivering robust Guidewire Core solutions for enterprise clients.",
    linkedin: "https://www.linkedin.com/in/meenakshi-vadivelu-92069331",
    tags: ["GW Core", "Architecture", "Platform Design"],
  },
  {
    id: "pa-digital",
    name: "Vishal Giri",
    title: "Principal Architect",
    sub_title: "(Guidewire Digital)",
    initials: "VG",
    color: "#a78bfa",
    experience: "15+",
    bio: "With over 15 years of industry experience, Vishal serves as Principal Architect specializing in Guidewire Digital at Protecons. His expertise in digital transformation and Guidewire Digital solutions drives innovative digital-first strategies for our clients.",
    linkedin: "https://www.linkedin.com/in/vishal-giri-43832a256",
    tags: ["GW Digital", "Digital Transform", "Innovation"],
  },
  {
    id: "func-arch",
    name: "Surendran Selvam",
    title: "Senior Architect",
    sub_title: "(QA Lead)",
    initials: "SS",
    color: "#ffd600",
    experience: "13+",
    bio: "With over 13 years of industry experience, Surendran leads Quality Assurance and serves as Functional Architect at Protecons. His expertise in QA strategy, functional analysis, and quality frameworks ensures all solutions meet the highest standards of excellence.",
    linkedin: "https://www.linkedin.com/in/surendran-selvam-4381148b",
    tags: ["Functional Arch", "QA Lead", "Quality"],
  },
  {
    id: "sa-core-int",
    name: "Nitin Singhvi",
    title: "Principal Architect",
    sub_title: "(Guidewire Core & Integrations)",
    initials: "NS",
    color: "#06b6d4",
    experience: "19+",
    bio: "With over 19 years of industry experience, Nitin serves as Principal Architect specializing in Guidewire core at Protecons. His deep expertise in Guidewire configuration and integration architecture ensures seamless, scalable solutions that connect complex enterprise systems.",
    linkedin: "https://www.linkedin.com/in/nitin-singhvi",
    tags: ["GW Core", "Integrations", "Configuration"],
  },
];

export const SKILL_TEAMS = [
  {
    id: "gw-dev",
    name: "Guidewire Developers",
    icon: "⚙️",
    color: "#00c2ff",
    count: "25+",
    countLabel: "ProtecoNINs",
    stat: "100% GW Certified",
    desc: "The core of Protecons — expert Gosu and Java developers with deep X-Center specialisation across PolicyCenter, BillingCenter, and ClaimCenter for global P&C carriers.",
    skills: [
      "Gosu",
      "PolicyCenter",
      "BillingCenter",
      "ClaimCenter",
      "Upgrades",
      "IGApps",
    ],
    cert: "All Guidewire Certified",
  },
  {
    id: "jutro",
    name: "Jutro & Frontend Specialists",
    icon: "⚛️",
    color: "#a78bfa",
    count: "8+",
    countLabel: "UI Engineers",
    stat: "JDP Certified",
    desc: "React-powered UI engineers specialising in the Jutro Design System and JDP framework — building accessible, responsive insurance portals for customers, agents, and vendors.",
    skills: [
      "Jutro",
      "JDP",
      "React",
      "TypeScript",
      "WCAG",
      "Component Library",
    ],
    cert: "JDP Framework Certified",
  },
  {
    id: "integration",
    name: "Integration Engineers",
    icon: "🔗",
    color: "#00e676",
    count: "10+",
    countLabel: "Engineers",
    stat: "AWS / Azure Certified",
    desc: "Specialists in connecting Guidewire to enterprise ecosystems via REST APIs, messaging queues, ETL pipelines, and legacy system bridges for seamless data flow.",
    skills: [
      "REST APIs",
      "Kafka",
      "ESB",
      "ETL Pipelines",
      "MuleSoft",
      "Legacy Bridge",
    ],
    cert: "AWS & Azure Certified",
  },
  {
    id: "cloud",
    name: "Cloud & DevOps",
    icon: "☁️",
    color: "#06b6d4",
    count: "6+",
    countLabel: "Platform Engineers",
    stat: "Multi-Cloud",
    desc: "Platform engineers managing Guidewire Cloud environments with CI/CD automation, Infrastructure-as-Code, and 24/7 observability across AWS, Azure, and GCP.",
    skills: ["AWS", "Azure", "GCP", "Kubernetes", "Terraform", "CI/CD"],
    cert: "Cloud Platform Certified",
  },
  {
    id: "qa",
    name: "QA & Test Automation",
    icon: "🧪",
    color: "#ffd600",
    count: "6+",
    countLabel: "QA Engineers",
    stat: "ISTQB Certified",
    desc: "Quality engineers running comprehensive test cycles — functional, regression, performance, and UAT — powered by our proprietary Pro(T) Automaton framework.",
    skills: [
      "Selenium",
      "Cypress",
      "JMeter",
      "Cucumber BDD",
      "Postman",
      "GW Testing",
    ],
    cert: "ISTQB Certified",
  },
  {
    id: "ba",
    name: "Business Analysts",
    icon: "📊",
    color: "#ff6b35",
    count: "5+",
    countLabel: "Domain Analysts",
    stat: "Insurance Domain",
    desc: "Insurance domain experts who translate business requirements into Guidewire configuration blueprints, bridging carrier stakeholders and delivery teams seamlessly.",
    skills: [
      "Requirements Analysis",
      "Insurance Domain",
      "JIRA",
      "Agile",
      "User Stories",
      "Data Mapping",
    ],
    cert: "CBAP / Domain Expert",
  },
];

export const EVENTS = [
  {
    id: "gw-connections-2024",
    title: "Guidewire Connections 2024",
    date: "2024-11-04",
    location: "Las Vegas, NV",
    type: "Conference",
    description:
      "Protecons represented as a Bronze Sponsor at the annual Guidewire Connections conference, connecting with carriers and implementation partners worldwide.",
    highlight: true,
  },
  {
    id: "team-offsite-2024",
    title: "Annual Team Offsite 2024",
    date: "2024-09-14",
    location: "Coorg, Karnataka",
    type: "Team",
    description:
      "ProtecoNINs gathered for 3 days of strategy sessions, team-building activities, and celebrating milestones achieved together.",
    highlight: false,
  },
  {
    id: "gwtc-2024",
    title: "Guidewire Certification Bootcamp",
    date: "2024-07-22",
    location: "Bangalore, India",
    type: "Training",
    description:
      "Internal Guidewire certification bootcamp with 15 new certifications earned across PolicyCenter, BillingCenter, and ClaimCenter.",
    highlight: false,
  },
  {
    id: "diwali-2023",
    title: "Diwali Celebration 2023",
    date: "2023-11-12",
    location: "Bangalore, India",
    type: "Culture",
    description:
      "Lighting up the office with joy — our annual Diwali bash with games, gifts, and our beloved team camaraderie.",
    highlight: false,
  },
  {
    id: "gw-connections-2023",
    title: "Guidewire Connections 2023",
    date: "2023-10-23",
    location: "Nashville, TN",
    type: "Conference",
    description:
      "Protecons strengthened its North America presence at Connections 2023, showcasing the Pro(T) product suite to top P&C carriers.",
    highlight: false,
  },
  {
    id: "founders-day-2023",
    title: "Founders Day — 5 Years of Protecons",
    date: "2023-03-01",
    location: "Bangalore, India",
    type: "Milestone",
    description:
      "Celebrating 5 years of Protecons — from a team of 3 to 50+ ProtecoNINs strong, delivering excellence across 5 continents.",
    highlight: true,
  },
];

export const PHOTO_CATEGORIES = [
  "All",
  "Annual Company Event",
  "CSR",
  "Employee Wellness",
  "Empowering Women",
  "Festive Celebrations",
  "GW DevSummit 2025",
];

export const PHOTO_GALLERY = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=600&q=75&auto=format&fit=crop",
    alt: "Guidewire Connections Conference",
    category: "Conference",
  },
  {
    id: 2,
    url: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=600&q=75&auto=format&fit=crop",
    alt: "Team Workshop Session",
    category: "Training",
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=600&q=75&auto=format&fit=crop",
    alt: "Team Celebration",
    category: "Culture",
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1515187029135-18ee286d815b?w=600&q=75&auto=format&fit=crop",
    alt: "Annual Team Offsite",
    category: "Team",
  },
  {
    id: 5,
    url: "https://images.unsplash.com/photo-1528605248644-14dd04022da1?w=600&q=75&auto=format&fit=crop",
    alt: "ProtecoNIN Team Building",
    category: "Team",
  },
  {
    id: 6,
    url: "https://images.unsplash.com/photo-1475721027785-f74eccf877e2?w=600&q=75&auto=format&fit=crop",
    alt: "Conference Keynote",
    category: "Conference",
  },
  {
    id: 7,
    url: "https://images.unsplash.com/photo-1540304453527-62f979142a17?w=600&q=75&auto=format&fit=crop",
    alt: "Diwali Office Celebration",
    category: "Culture",
  },
  {
    id: 8,
    url: "https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?w=600&q=75&auto=format&fit=crop",
    alt: "Certification Achievement",
    category: "Milestone",
  },
  {
    id: 9,
    url: "https://images.unsplash.com/photo-1552581234-26160f608093?w=600&q=75&auto=format&fit=crop",
    alt: "Team Strategy Session",
    category: "Training",
  },
  {
    id: 10,
    url: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=600&q=75&auto=format&fit=crop",
    alt: "Office Collaboration",
    category: "Team",
  },
  {
    id: 11,
    url: "https://images.unsplash.com/photo-1559136555-9303baea8ebd?w=600&q=75&auto=format&fit=crop",
    alt: "Conference Networking",
    category: "Conference",
  },
  {
    id: 12,
    url: "https://images.unsplash.com/photo-1531482615713-2afd69097998?w=600&q=75&auto=format&fit=crop",
    alt: "Company Milestone Event",
    category: "Milestone",
  },
];

export const AI_USE_CASES = [
  {
    icon: "🔍",
    title: "Intelligent Claims Triage",
    desc: "ML models automatically classify and route incoming claims based on complexity, fraud risk, and coverage type — reducing manual triage time by up to 70%.",
    color: "#ff6b35",
  },
  {
    icon: "📄",
    title: "Document Intelligence",
    desc: "NLP-powered extraction from FNOL forms, medical records, contracts, and policy documents — transforming unstructured data into structured Guidewire records.",
    color: "#a78bfa",
  },
  {
    icon: "🛡️",
    title: "AI Fraud Detection",
    desc: "Graph analytics and anomaly detection models identify suspicious claims patterns and policy stacking in real time, integrated directly into ClaimCenter workflows.",
    color: "#ffd600",
  },
  {
    icon: "💡",
    title: "Smart Underwriting",
    desc: "Predictive risk models provide real-time underwriting recommendations in PolicyCenter — scoring applicants against historical loss data and external signals.",
    color: "#00e676",
  },
  {
    icon: "💬",
    title: "Insurance AI Agents",
    desc: "LLM-powered autonomous agents handle FNOL intake, policy queries, and renewal negotiations — available 24/7 and fully integrated with Guidewire backends.",
    color: "#06b6d4",
  },
  {
    icon: "📈",
    title: "Predictive Analytics",
    desc: "Data science pipelines combining Guidewire operational data with external signals for loss ratio forecasting, churn prediction, and portfolio risk analysis.",
    color: "#f472b6",
  },
];

export const AI_GW_SYNERGY = [
  {
    xcenter: "PolicyCenter",
    color: "#00c2ff",
    aiFeature: "Smart Underwriting AI",
    desc: "AI models embedded into PolicyCenter underwriting workflows score applications, recommend coverage, and flag high-risk policies — all without leaving the Guidewire UI.",
    gains: [
      "30% faster underwriting decisions",
      "Real-time risk scoring at point of quote",
      "LLM-generated policy summaries for agents",
    ],
  },
  {
    xcenter: "ClaimCenter",
    color: "#ffd600",
    aiFeature: "Intelligent Claims Engine",
    desc: "From AI-driven FNOL to automated reserve setting and fraud detection — our AI layer makes ClaimCenter smarter at every step of the claims lifecycle.",
    gains: [
      "70% reduction in manual triage",
      "Automated reserve recommendations",
      "Real-time fraud risk scoring",
    ],
  },
  {
    xcenter: "BillingCenter",
    color: "#00e676",
    aiFeature: "Payment Intelligence",
    desc: "ML models predict payment delinquency before it happens, optimise payment plan offerings, and detect billing fraud — integrated directly into BillingCenter workflows.",
    gains: [
      "Predictive delinquency alerts",
      "Personalised payment plan AI",
      "Billing anomaly detection",
    ],
  },
];

export const NON_GW_CAPABILITIES = [
  {
    id: "ai-ml",
    title: "AI & Machine Learning",
    description:
      "End-to-end AI and ML solutions purpose-built for insurance — from Generative AI integrations and LLM-powered document processing to predictive risk models and intelligent claims automation.",
    features: [
      "Generative AI (LLM Integration)",
      "NLP & Document Intelligence",
      "Predictive Risk Modelling",
      "Intelligent Claims Automation",
      "ML Fraud Detection",
      "AI-Powered Underwriting",
    ],
    color: "#6366f1",
    icon: "🤖",
  },
  {
    id: "java-fullstack",
    title: "Java Full Stack",
    description:
      "Enterprise-grade Java application development with Spring Boot microservices, REST & GraphQL APIs, JPA/Hibernate ORM, and robust testing pipelines. Proven for large-scale insurance platform integrations.",
    features: [
      "Spring Boot & Microservices",
      "REST & GraphQL APIs",
      "JPA / Hibernate ORM",
      "JUnit & Mockito Testing",
      "Maven / Gradle Build",
      "Event-Driven Architecture",
    ],
    color: "#ff6b35",
    icon: "☕",
  },
  {
    id: "react-frontend",
    title: "React & Modern Frontend",
    description:
      "High-performance React applications with TypeScript, advanced state management, component libraries, and accessibility compliance. From design systems to production-grade insurance portals.",
    features: [
      "React 18 + TypeScript",
      "Redux / Zustand State",
      "Material UI / Tailwind CSS",
      "Jest & Testing Library",
      "Vite / Webpack Build",
      "WCAG Accessibility",
    ],
    color: "#06b6d4",
    icon: "⚛️",
  },
  {
    id: "cloud-devops",
    title: "Cloud & DevOps",
    description:
      "Cloud-native infrastructure design, CI/CD pipeline automation, containerisation, and observability across AWS, Azure, and GCP — enabling faster, safer software delivery at enterprise scale.",
    features: [
      "AWS / Azure / GCP",
      "Docker & Kubernetes",
      "Terraform IaC",
      "Jenkins / GitHub Actions",
      "Prometheus & Grafana",
      "CloudWatch & Alerting",
    ],
    color: "#a78bfa",
    icon: "☁️",
  },
  {
    id: "data-analytics",
    title: "Data & Analytics",
    description:
      "Insurance data platform design, ETL pipeline development, real-time analytics dashboards, and data warehouse solutions. Transforming raw insurance data into actionable business intelligence.",
    features: [
      "ETL Pipeline Design",
      "Apache Spark & Kafka",
      "Snowflake / Redshift",
      "Power BI & Tableau",
      "Data Quality Governance",
      "ML Feature Engineering",
    ],
    color: "#00e676",
    icon: "📊",
  },
  {
    id: "qa-automation",
    title: "QA & Test Automation",
    description:
      "Comprehensive quality assurance spanning manual testing, Selenium/Cypress automation, API testing, performance testing, and CI-integrated regression suites for insurance platforms.",
    features: [
      "Selenium & Cypress E2E",
      "RestAssured & Postman",
      "JMeter Performance",
      "BDD with Cucumber",
      "CI-Integrated Regression",
      "Mobile Testing (Appium)",
    ],
    color: "#ffd600",
    icon: "🧪",
  },
  {
    id: "salesforce",
    title: "Salesforce & CRM",
    description:
      "Salesforce implementation, customisation, and integration for insurance carriers — Sales Cloud, Financial Services Cloud, custom Lightning Web Components, and MuleSoft integrations.",
    features: [
      "Sales Cloud & Service Cloud",
      "Financial Services Cloud",
      "Lightning Web Components",
      "Salesforce Apex",
      "MuleSoft Integration",
      "Marketing Cloud",
    ],
    color: "#f472b6",
    icon: "🔵",
  },
];

export const CAREER_OPENINGS = [
  // ── LEAD ──────────────────────────────────────────────────────
  {
    id: "gw-cloud-architect",
    title: "Guidewire Cloud Architect",
    level: "Lead",
    type: "Full-time",
    location: "Bangalore / Remote",
    experience: "10+ yrs IT · 5+ yrs Guidewire",
    module: "Cloud",
    description:
      "Lead cloud transformation initiatives on Guidewire Cloud Platform (GWCP) — architecting scalable, secure, high-availability solutions and driving migration from on-premise to cloud for global P&C carriers.",
    tags: [
      "GWCP",
      "PolicyCenter",
      "ClaimCenter",
      "BillingCenter",
      "AWS / Azure / GCP",
      "Microservices",
      "Docker",
      "Kubernetes",
      "CI/CD",
    ],
    mustHave: [
      "Guidewire Cloud implementation or migration experience",
      "Deep expertise in at least one GW module (PC / BC / CC)",
      "Cloud-native architecture design experience",
      "Strong API and integration design experience",
      "Containerization with Docker and Kubernetes",
      "Ability to lead architecture discussions and make strategic decisions",
    ],
    goodToHave: [
      "Guidewire certifications (Cloud / ACE / Specialist)",
      "GW Cloud upgrades experience (e.g. Aspen → Mammoth)",
      "Insurance domain knowledge — P&C preferred",
      "AI-driven testing or automation in Guidewire",
      "Observability tools (Splunk, Dynatrace)",
      "Experience with global clients / distributed teams",
    ],
  },
  {
    id: "cc-lead",
    title: "Guidewire ClaimCenter Lead",
    level: "Lead",
    type: "Full-time",
    location: "Bangalore / Remote",
    experience: "8–12 yrs IT · 5+ yrs ClaimCenter",
    module: "ClaimCenter",
    description:
      "Lead end-to-end delivery of ClaimCenter implementations and enhancements, driving solution design, configuration, and team leadership with strong functional and technical expertise.",
    tags: [
      "ClaimCenter",
      "Gosu",
      "REST / SOAP",
      "Agile / Scrum",
      "Team Leadership",
      "CI/CD",
    ],
    mustHave: [
      "Deep expertise in Guidewire ClaimCenter (configuration & development)",
      "Strong Gosu programming knowledge",
      "Experience leading teams or modules in Guidewire projects",
      "Hands-on experience with integrations and APIs",
      "Understanding of claims lifecycle and business processes",
      "Experience in Guidewire upgrades or implementation projects",
    ],
    goodToHave: [
      "Guidewire certifications (ClaimCenter / ACE)",
      "Exposure to Guidewire Cloud Platform (GWCP)",
      "Performance tuning and batch processes experience",
      "Knowledge of Insurance domain — P&C preferred",
      "Exposure to testing frameworks and automation",
      "Experience with global clients or distributed teams",
    ],
  },
  {
    id: "pc-lead",
    title: "Guidewire PolicyCenter Lead",
    level: "Lead",
    type: "Full-time",
    location: "Bangalore / Remote",
    experience: "8–12 yrs IT · 5+ yrs PolicyCenter",
    module: "PolicyCenter",
    description:
      "Lead underwriting and policy administration implementations, driving solution design, team leadership, and high-quality delivery across PolicyCenter programs.",
    tags: [
      "PolicyCenter",
      "Gosu",
      "REST / SOAP",
      "Agile / Scrum",
      "Product Model",
      "Team Leadership",
    ],
    mustHave: [
      "Deep expertise in Guidewire PolicyCenter (configuration & development)",
      "Strong Gosu programming knowledge",
      "Experience leading teams/modules in Guidewire implementations",
      "Hands-on API integrations and external system connectivity",
      "Strong understanding of policy lifecycle, underwriting, and rating processes",
      "Experience in Guidewire implementations or upgrade projects",
    ],
    goodToHave: [
      "Guidewire certifications (PolicyCenter / ACE)",
      "Exposure to Guidewire Cloud Platform (GWCP)",
      "Experience with product model configuration and rating engines",
      "Knowledge of Insurance domain — P&C preferred",
      "Exposure to test automation frameworks",
      "Experience with global clients or distributed teams",
    ],
  },
  {
    id: "gw-test-lead",
    title: "Guidewire Manual & Automation Senior Test Lead",
    level: "Lead",
    type: "Full-time",
    location: "Bangalore / Remote",
    experience: "8–12 yrs QA · 5+ yrs Guidewire testing",
    module: "QA",
    description:
      "Lead QA strategy, testing teams, and scalable automation frameworks for Guidewire programs — driving test automation roadmap, CI/CD integration, and quality excellence across multiple concurrent projects.",
    tags: [
      "Guidewire Testing",
      "Test Automation",
      "Selenium",
      "API Testing",
      "CI/CD",
      "Team Leadership",
    ],
    mustHave: [
      "Proven experience leading Guidewire QA / testing teams",
      "Strong expertise in test strategy, planning, and execution",
      "Hands-on test automation framework design and implementation",
      "Experience in API and integration testing",
      "Strong understanding of SDLC / STLC and Agile delivery",
      "Ability to manage stakeholders, risks, and quality metrics effectively",
    ],
    goodToHave: [
      "Guidewire testing certifications",
      "Exposure to Guidewire Cloud Platform (GWCP)",
      "BDD frameworks (Cucumber, SpecFlow)",
      "Performance testing tools (JMeter, LoadRunner)",
      "AI-driven testing tools and predictive QA approaches",
      "Experience with global clients or distributed teams",
    ],
  },
  // ── SENIOR ────────────────────────────────────────────────
  {
    id: "api-integration-architect",
    title: "Senior API Integration Architect",
    level: "Senior",
    type: "Full-time",
    location: "Bangalore / Remote",
    experience: "6–10 yrs IT · 4+ yrs Guidewire integrations",
    module: "Cloud",
    description:
      "Design and deliver enterprise-grade API and integration architectures for Guidewire ecosystems — connecting PolicyCenter, ClaimCenter, and BillingCenter with third-party systems via REST, SOAP, and event-driven patterns.",
    tags: [
      "REST / SOAP",
      "Integration Gateway",
      "MuleSoft",
      "Kafka",
      "Apigee",
      "Gosu",
      "GWCP",
    ],
    mustHave: [
      "Hands-on Guidewire API and integration development experience",
      "Strong knowledge of REST and SOAP web services design",
      "Experience with middleware platforms (MuleSoft, Apigee, or similar)",
      "Familiarity with Guidewire Integration Gateway (IG Apps)",
      "Event-driven architecture experience (Kafka, JMS, or similar)",
      "Ability to lead integration architecture discussions",
    ],
    goodToHave: [
      "Guidewire Cloud Platform (GWCP) experience",
      "Guidewire certifications (Integration / ACE)",
      "Experience with API security (OAuth2, JWT)",
      "Knowledge of Insurance domain — P&C preferred",
      "CI/CD pipelines and DevOps practices",
      "Experience with global or distributed teams",
    ],
  },
  {
    id: "gw-cloud-senior-dev",
    title: "Senior Guidewire Developer / Cloud Developer",
    level: "Senior",
    type: "Full-time",
    location: "Bangalore / Remote",
    experience: "6–10 yrs IT · 3+ yrs Guidewire Cloud",
    module: "Cloud",
    description:
      "Develop and configure Guidewire solutions on Cloud Platform (GWCP) — implementing cloud-native features, upgrades, and integrations across PolicyCenter, ClaimCenter, and BillingCenter for global P&C carriers.",
    tags: [
      "GWCP",
      "Gosu",
      "Cloud Migration",
      "REST APIs",
      "Docker",
      "CI/CD",
      "Microservices",
    ],
    mustHave: [
      "Hands-on Guidewire Cloud Platform (GWCP) development experience",
      "Strong Gosu programming and data model expertise",
      "Experience with at least one Guidewire module (PC / CC / BC)",
      "Cloud-native development and deployment practices",
      "API integration and third-party system connectivity",
      "Experience with Guidewire cloud migration or upgrade projects",
    ],
    goodToHave: [
      "Guidewire certifications (Cloud Developer / ACE)",
      "Container orchestration (Docker, Kubernetes)",
      "Knowledge of AWS, Azure, or GCP",
      "Insurance domain knowledge — P&C preferred",
      "CI/CD toolchain experience (Jenkins, GitHub Actions)",
      "Experience with global or distributed teams",
    ],
  },
  {
    id: "cc-senior-dev",
    title: "Guidewire ClaimCenter Senior Developer",
    level: "Senior",
    type: "Full-time",
    location: "Bangalore / Remote",
    experience: "5–9 yrs IT · 3+ yrs ClaimCenter",
    module: "ClaimCenter",
    description:
      "Design, develop, and maintain high-quality solutions in Guidewire ClaimCenter — configuration, customization, integrations, and mentoring junior developers on global P&C carrier implementations.",
    tags: [
      "ClaimCenter",
      "Gosu",
      "PCF",
      "Data Model",
      "REST / SOAP",
      "Business Rules",
    ],
    mustHave: [
      "Hands-on development experience in Guidewire ClaimCenter",
      "Strong expertise in Gosu, PCF, and Data Model",
      "Experience building and consuming APIs",
      "Solid understanding of claims lifecycle and processes",
      "Experience in at least one end-to-end implementation or upgrade project",
      "Ability to work independently and contribute to design discussions",
    ],
    goodToHave: [
      "Guidewire certifications (ClaimCenter Developer / ACE)",
      "Exposure to Guidewire Cloud Platform (GWCP)",
      "Experience with batch processes and performance tuning",
      "Knowledge of Insurance domain — P&C preferred",
      "Exposure to test automation frameworks",
      "Experience with distributed / global teams",
    ],
  },
  {
    id: "bc-senior-dev",
    title: "Guidewire BillingCenter Senior Developer",
    level: "Senior",
    type: "Full-time",
    location: "Bangalore / Remote",
    experience: "5–9 yrs IT · 3+ yrs BillingCenter",
    module: "BillingCenter",
    description:
      "Design and develop scalable solutions in Guidewire BillingCenter — billing workflows, payment integrations, and system customization ensuring seamless financial operations within Guidewire ecosystems.",
    tags: [
      "BillingCenter",
      "Gosu",
      "PCF",
      "Data Model",
      "REST / SOAP",
      "Billing Workflows",
    ],
    mustHave: [
      "Hands-on development experience in Guidewire BillingCenter",
      "Strong expertise in Gosu, PCF, and Data Model",
      "Experience with billing workflows (invoicing, payments, collections, commissions)",
      "Experience building and consuming APIs and integrations",
      "Understanding of billing lifecycle and financial processes",
      "Experience in at least one end-to-end implementation or upgrade project",
    ],
    goodToHave: [
      "Guidewire certifications (BillingCenter Developer / ACE)",
      "Exposure to Guidewire Cloud Platform (GWCP)",
      "Experience with payment gateway integrations",
      "Knowledge of Insurance domain — P&C preferred",
      "Batch processing and performance tuning experience",
      "Experience with global or distributed teams",
    ],
  },
  {
    id: "pc-senior-dev",
    title: "Guidewire PolicyCenter Senior Developer",
    level: "Senior",
    type: "Full-time",
    location: "Bangalore / Remote",
    experience: "5–9 yrs IT · 3+ yrs PolicyCenter",
    module: "PolicyCenter",
    description:
      "Design, develop, and maintain solutions in Guidewire PolicyCenter — product model, underwriting workflows, and policy lifecycle implementations with deep Gosu and integration expertise.",
    tags: [
      "PolicyCenter",
      "Gosu",
      "PCF",
      "Product Model",
      "REST / SOAP",
      "Underwriting",
    ],
    mustHave: [
      "Hands-on development experience in Guidewire PolicyCenter",
      "Strong expertise in Gosu, PCF, Data Model, and Product Model",
      "Experience with policy lifecycle (quote, bind, issue, renew, endorse, cancel)",
      "Strong understanding of underwriting and rating processes",
      "Experience in API integrations and external system connectivity",
      "Experience in at least one end-to-end implementation or upgrade project",
    ],
    goodToHave: [
      "Guidewire certifications (PolicyCenter Developer / ACE)",
      "Exposure to Guidewire Cloud Platform (GWCP)",
      "Rating engine configuration and optimization",
      "Knowledge of Insurance domain — P&C preferred",
      "Performance tuning and batch processes",
      "Experience with global or distributed teams",
    ],
  },
  {
    id: "cc-senior-ba",
    title: "Guidewire ClaimCenter Senior Business Analyst",
    level: "Senior",
    type: "Full-time",
    location: "Bangalore / Remote",
    experience: "6–10 yrs BA · 3+ yrs ClaimCenter",
    module: "ClaimCenter",
    description:
      "Bridge business and technology for ClaimCenter — driving requirement analysis, stakeholder collaboration, and successful claims transformation initiatives through expert documentation and UAT leadership.",
    tags: [
      "ClaimCenter",
      "Business Analysis",
      "Claims Lifecycle",
      "JIRA",
      "Agile",
      "UAT",
      "BRD / FSD",
    ],
    mustHave: [
      "Experience working on Guidewire ClaimCenter projects",
      "Strong knowledge of claims processes and lifecycle (FNOL, adjudication, payments)",
      "Expertise in requirement elicitation and documentation (BRD, FSD, user stories)",
      "Experience in UAT coordination and defect management",
      "Ability to bridge business and technical teams effectively",
      "Strong stakeholder management skills",
    ],
    goodToHave: [
      "Guidewire Business Analyst / ClaimCenter certification",
      "Exposure to Guidewire Cloud Platform (GWCP)",
      "P&C insurance domain experience",
      "Familiarity with integration concepts (APIs, data flow)",
      "Experience with JIRA, Confluence, or similar tools",
      "Experience with global stakeholders or distributed teams",
    ],
  },
  {
    id: "gw-test-engineer",
    title: "Guidewire Manual & Automation Senior Test Engineer",
    level: "Senior",
    type: "Full-time",
    location: "Bangalore / Remote",
    experience: "5–9 yrs QA · 3+ yrs Guidewire testing",
    module: "QA",
    description:
      "Design and execute manual and automated test strategies for Guidewire applications — building robust automation frameworks and ensuring high-quality delivery across ClaimCenter, PolicyCenter, and BillingCenter.",
    tags: [
      "Guidewire Testing",
      "Selenium",
      "TestNG",
      "Cucumber",
      "Postman",
      "Rest Assured",
      "CI/CD",
    ],
    mustHave: [
      "Hands-on experience in Guidewire testing (any module)",
      "Strong expertise in test case design and execution",
      "Experience in automation scripting (Selenium or similar tools)",
      "Experience in API testing and integration validation",
      "Strong understanding of SDLC / STLC processes",
      "Ability to work independently and ensure quality delivery",
    ],
    goodToHave: [
      "Guidewire testing certifications",
      "Exposure to Guidewire Cloud Platform (GWCP)",
      "BDD frameworks (Cucumber, SpecFlow)",
      "Performance testing tools (JMeter, LoadRunner)",
      "Exposure to AI-driven testing tools or frameworks",
      "Experience with global teams or distributed environments",
    ],
  },
  {
    id: "cc-integration-lead",
    title: "Guidewire ClaimCenter Senior Developer / Tech Lead – IG Apps",
    level: "Senior",
    type: "Full-time",
    location: "Bangalore / Remote",
    experience: "3–8 yrs Guidewire ClaimCenter",
    module: "ClaimCenter",
    description:
      "Specialize in Guidewire Integration Gateway (IG Apps) — design and develop cloud-based integrations for ClaimCenter with REST/SOAP APIs, event-driven messaging, and middleware platforms like Kafka and MuleSoft.",
    tags: [
      "ClaimCenter",
      "Integration Gateway",
      "IG Apps",
      "Gosu",
      "Kafka",
      "REST / SOAP",
      "GWCP",
    ],
    mustHave: [
      "Guidewire Certifications (ClaimCenter or Integration)",
      "Experience with Guidewire Cloud Platform (GWCP)",
      "Hands-on Integration Gateway (IG Apps) experience",
      "Strong knowledge of Gosu, Guidewire APIs, and data model",
      "Experience building REST / SOAP web services",
      "Familiarity with messaging systems (Kafka, JMS)",
    ],
    goodToHave: [
      "CI/CD pipelines and DevOps practices",
      "Exposure to MuleSoft / Apigee / other API gateways",
      "Experience with XML, JSON, XSD, WSDL",
      "Understanding of Guidewire Digital / Integration frameworks",
    ],
  },
  // ── MID ────────────────────────────────────────────────────────
  {
    id: "pc-developer",
    title: "Guidewire PolicyCenter Developer",
    level: "Mid",
    type: "Full-time",
    location: "Bangalore / Remote",
    experience: "3+ yrs IT · 2+ yrs PolicyCenter",
    module: "PolicyCenter",
    description:
      "Develop and configure Guidewire PolicyCenter solutions — implementing policy lifecycle workflows, product model customizations, and integrations for P&C insurance carriers under senior developer guidance.",
    tags: [
      "PolicyCenter",
      "Gosu",
      "PCF",
      "Data Model",
      "REST APIs",
      "Product Model",
    ],
    mustHave: [
      "Working knowledge of Guidewire PolicyCenter configuration and development",
      "Familiarity with Gosu programming language",
      "Basic understanding of policy lifecycle (quote, bind, issue, renew)",
      "Experience with PCF and data model customization",
      "Ability to build and consume REST / SOAP APIs",
      "Good analytical and problem-solving skills",
    ],
    goodToHave: [
      "Guidewire PolicyCenter Developer certification",
      "Exposure to Guidewire Cloud Platform (GWCP)",
      "Knowledge of Insurance domain — P&C preferred",
      "Experience with unit testing and code review practices",
      "Familiarity with Agile / Scrum delivery methodology",
    ],
  },
  {
    id: "cc-developer",
    title: "Guidewire ClaimCenter Developer",
    level: "Mid",
    type: "Full-time",
    location: "Bangalore / Remote",
    experience: "3+ yrs IT · 2+ yrs ClaimCenter",
    module: "ClaimCenter",
    description:
      "Develop and configure Guidewire ClaimCenter solutions — implementing claims workflows, business rules, and system integrations for P&C insurance carriers as part of a collaborative delivery team.",
    tags: [
      "ClaimCenter",
      "Gosu",
      "PCF",
      "Data Model",
      "REST APIs",
      "Business Rules",
    ],
    mustHave: [
      "Working knowledge of Guidewire ClaimCenter configuration and development",
      "Familiarity with Gosu programming language",
      "Basic understanding of claims lifecycle (FNOL, adjudication, payments)",
      "Experience with PCF and data model customization",
      "Ability to build and consume REST / SOAP APIs",
      "Good analytical and problem-solving skills",
    ],
    goodToHave: [
      "Guidewire ClaimCenter Developer certification",
      "Exposure to Guidewire Cloud Platform (GWCP)",
      "Knowledge of Insurance domain — P&C preferred",
      "Experience with unit testing and code review practices",
      "Familiarity with Agile / Scrum delivery methodology",
    ],
  },
  {
    id: "bc-developer",
    title: "Guidewire BillingCenter Developer",
    level: "Mid",
    type: "Full-time",
    location: "Bangalore / Remote",
    experience: "3+ yrs IT · 2+ yrs BillingCenter",
    module: "BillingCenter",
    description:
      "Develop and configure Guidewire BillingCenter solutions — implementing billing workflows, payment processing logic, and integrations for P&C insurance carriers within collaborative delivery teams.",
    tags: [
      "BillingCenter",
      "Gosu",
      "PCF",
      "Data Model",
      "REST APIs",
      "Billing Workflows",
    ],
    mustHave: [
      "Working knowledge of Guidewire BillingCenter configuration and development",
      "Familiarity with Gosu programming language",
      "Basic understanding of billing lifecycle (invoicing, payments, collections)",
      "Experience with PCF and data model customization",
      "Ability to build and consume REST / SOAP APIs",
      "Good analytical and problem-solving skills",
    ],
    goodToHave: [
      "Guidewire BillingCenter Developer certification",
      "Exposure to Guidewire Cloud Platform (GWCP)",
      "Knowledge of Insurance domain — P&C preferred",
      "Experience with payment gateway integrations",
      "Familiarity with Agile / Scrum delivery methodology",
    ],
  },
  {
    id: "gw-digital-portal-dev",
    title: "Guidewire Digital Portal Developer",
    level: "Mid",
    type: "Full-time",
    location: "Bangalore / Remote",
    experience: "3–6 yrs IT · 2+ yrs Guidewire Digital",
    module: "Cloud",
    description:
      "Build and customize Guidewire Digital portals using the Jutro framework — developing agent, policyholder, and vendor portals that integrate seamlessly with PolicyCenter, ClaimCenter, and BillingCenter backends.",
    tags: [
      "Guidewire Digital",
      "Jutro",
      "React",
      "JavaScript",
      "REST APIs",
      "CSS",
      "Portal Dev",
    ],
    mustHave: [
      "Experience developing Guidewire Digital portal applications",
      "Proficiency in Jutro framework and React-based UI development",
      "Strong JavaScript and modern web development skills",
      "Experience integrating portals with Guidewire backend APIs",
      "Understanding of responsive design and accessibility standards",
      "Familiarity with Guidewire data model and entity concepts",
    ],
    goodToHave: [
      "Guidewire Digital / Jutro certification",
      "Exposure to Guidewire Cloud Platform (GWCP)",
      "Knowledge of Insurance domain — P&C preferred",
      "Experience with REST API design and Swagger/OpenAPI",
      "CI/CD pipeline and DevOps practices",
    ],
  },
  {
    id: "jutro-ui-developer",
    title: "Jutro UI Developer – Guidewire Digital",
    level: "Mid",
    type: "Full-time",
    location: "Bangalore / Remote",
    experience: "3–6 yrs · 2+ yrs Jutro / Guidewire Digital",
    module: "Cloud",
    description:
      "Specialize in Jutro UI development for Guidewire Digital portals — crafting responsive, accessible, and performant interfaces for policyholder, agent, and vendor self-service journeys using the Guidewire Digital suite.",
    tags: [
      "Jutro",
      "React",
      "JavaScript",
      "Guidewire Digital",
      "REST APIs",
      "UI Development",
      "CSS",
    ],
    mustHave: [
      "Hands-on Jutro framework development experience",
      "Strong React and JavaScript development skills",
      "Experience building Guidewire Digital portals",
      "Proficiency in REST API integration from the frontend",
      "Good understanding of UI/UX principles and web accessibility",
      "Familiarity with Guidewire APIs and data structures",
    ],
    goodToHave: [
      "Guidewire Digital / Jutro certification",
      "Experience with Guidewire Cloud Platform (GWCP)",
      "Knowledge of P&C insurance processes",
      "Experience with Jest or similar frontend testing tools",
      "Familiarity with design systems or component libraries",
    ],
  },
  {
    id: "gw-cloud-developer",
    title: "Guidewire Developer / Cloud Developer",
    level: "Mid",
    type: "Full-time",
    location: "Bangalore / Remote",
    experience: "3–6 yrs IT · 2+ yrs Guidewire Cloud",
    module: "Cloud",
    description:
      "Develop Guidewire solutions on the Cloud Platform (GWCP) — implementing cloud-native configurations, integrations, and upgrades for PolicyCenter, ClaimCenter, or BillingCenter in fast-moving P&C carrier programs.",
    tags: [
      "GWCP",
      "Gosu",
      "Cloud Development",
      "REST APIs",
      "Docker",
      "CI/CD",
      "Microservices",
    ],
    mustHave: [
      "Hands-on Guidewire Cloud Platform (GWCP) development experience",
      "Proficiency in Gosu and Guidewire data model",
      "Experience with at least one Guidewire module (PC / CC / BC)",
      "Understanding of cloud-native deployment and CI/CD practices",
      "API integration experience with REST or SOAP",
      "Ability to work independently in Agile environments",
    ],
    goodToHave: [
      "Guidewire Cloud Developer certification",
      "Familiarity with Docker and container-based deployments",
      "Knowledge of AWS, Azure, or GCP basics",
      "Insurance domain knowledge — P&C preferred",
      "Experience with cloud migration or upgrade projects",
    ],
  },
  {
    id: "pc-rating-developer",
    title: "Guidewire PolicyCenter Developer – Rating",
    level: "Mid",
    type: "Full-time",
    location: "Bangalore / Remote",
    experience: "3–6 yrs IT · 2+ yrs PolicyCenter Rating",
    module: "PolicyCenter",
    description:
      "Specialize in Guidewire PolicyCenter rating — configuring and developing rating worksheets, rating routines, and product model to support complex insurance product pricing and underwriting automation.",
    tags: [
      "PolicyCenter",
      "Rating",
      "Gosu",
      "Product Model",
      "Rating Worksheets",
      "Underwriting",
      "REST APIs",
    ],
    mustHave: [
      "Hands-on experience with Guidewire PolicyCenter rating configuration",
      "Strong knowledge of rating worksheets and rating routines",
      "Proficiency in Gosu programming and data model",
      "Understanding of product model and coverage configuration",
      "Experience with underwriting rules and eligibility logic",
      "Ability to translate actuarial rate tables into Guidewire configurations",
    ],
    goodToHave: [
      "Guidewire PolicyCenter Developer / Rating certification",
      "Exposure to Guidewire Cloud Platform (GWCP)",
      "Knowledge of P&C insurance pricing and actuarial concepts",
      "Experience with third-party rating services integration",
      "Familiarity with Agile delivery in insurance programs",
    ],
  },
];

export const CULTURE_PERKS = [
  {
    icon: "🎓",
    title: "Certification Support",
    desc: "At Protecons, we empower employees through continuous learning, certification support, and growth opportunities to help them build future-ready careers.",
  },
  {
    icon: "🌍",
    title: "Global Exposure",
    desc: "As a growing startup, Protecons offers employees the opportunity to work with global clients across diverse industries, gaining valuable international exposure and impactful project experience.",
  },

  {
    icon: "📈",
    title: "Fast Growth",
    desc: "Growth at Protecons is driven by ownership, innovation, and opportunity. Our startup culture enables employees to take initiative, grow faster, and make meaningful contributions from day one.",
  },
  {
    icon: "🤸",
    title: "Flexible Working",
    desc: "We foster a flexible and people-first culture where employees are trusted to work with autonomy while maintaining collaboration, productivity, and work-life balance in a dynamic startup environment.",
  },
  {
    icon: "🎉",
    title: "Vibrant Culture",
    desc: "At Protecons, our culture is built on collaboration, positivity, and the spirit of “Do Good, Be Good.” Through celebrations, learning initiatives, and team engagement, we create an energetic workplace where people thrive together.",
  },
];

export const MOBILE_WEB_SERVICES = {
  phases: [
    {
      id: "requirements",
      title: "Requirements",
      icon: "📋",
      color: "#00c2ff",
      desc: "Business analysis, user stories, feature mapping and scope definition to create a clear, actionable roadmap.",
    },
    {
      id: "design",
      title: "UI/UX Design",
      icon: "🎨",
      color: "#a78bfa",
      desc: "Wireframes, prototypes, design systems and user journey mapping crafted for optimal experience and conversions.",
    },
    {
      id: "development",
      title: "Development",
      icon: "⚙️",
      color: "#00e676",
      desc: "Scalable frontend and backend using React Native, Flutter, React, Node.js, and Spring Boot.",
    },
    {
      id: "testing",
      title: "Testing & QA",
      icon: "🧪",
      color: "#ffd600",
      desc: "Comprehensive functional, regression, performance and security testing ensuring production-ready quality.",
    },
    {
      id: "deployment",
      title: "Deployment",
      icon: "🚀",
      color: "#ff6b35",
      desc: "CI/CD pipelines, cloud hosting and infrastructure-as-code for smooth, zero-downtime releases.",
    },
    {
      id: "appstore",
      title: "App Store",
      icon: "📱",
      color: "#f472b6",
      desc: "End-to-end publishing to Google Play and Apple App Store with compliance and review support.",
    },
  ],
  platforms: [
    {
      name: "Android",
      icon: "🤖",
      color: "#00e676",
      desc: "Native and cross-platform Android apps in Kotlin, Java and React Native for all Android devices and screen sizes.",
      tags: ["Kotlin", "Java", "React Native", "Google Play"],
    },
    {
      name: "iOS / Apple",
      icon: "🍎",
      color: "#a78bfa",
      desc: "Native iOS apps in Swift and SwiftUI, plus cross-platform with React Native — optimised for iPhone and iPad.",
      tags: ["Swift", "SwiftUI", "React Native", "App Store"],
    },
    {
      name: "Web Applications",
      icon: "🌐",
      color: "#00c2ff",
      desc: "Responsive web apps with React, Next.js and TypeScript — from portals and dashboards to full enterprise platforms.",
      tags: ["React", "Next.js", "TypeScript", "Node.js"],
    },
  ],
};

// Optimized image URLs (Unsplash CDN w/ compression params)
export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1551434678-e076c223a692?w=1200&q=80&auto=format&fit=crop",
  about:
    "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=600&q=75&auto=format&fit=crop",
  team: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=600&q=75&auto=format&fit=crop",
  cloud:
    "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=600&q=75&auto=format&fit=crop",
  office:
    "https://images.unsplash.com/photo-1497366216548-37526070297c?w=600&q=75&auto=format&fit=crop",
  consulting:
    "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=75&auto=format&fit=crop",
  digital:
    "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&q=75&auto=format&fit=crop",
  data: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&q=75&auto=format&fit=crop",
};
